import { addToast } from "actions/ui";
import Button, { ButtonType } from "components/Button";
import Input, { InputType } from "components/Input";
import Loader from "components/Loader";
import React, { Component, Fragment } from "react";
import { Trans, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { TucanoActions, TucanoSelectors } from "web-api/main";

import style from "./style.module.css";

const ADULT_CODE_REGEXP = /^[0-9]*$/;

/* WARNING :
 * adultCode must be handled as a string to work with code that starts with zero
 */
class FormChangeParentalCode extends Component {
  state = {
    data: {
      currentParentalCode: "",
      newParentalCode: "",
      confirmNewParentalCode: "",
    },
    error: {
      currentParentalCode: "",
      newParentalCode: "",
      confirmNewParentalCode: "",
    },
    focus: {
      currentParentalCode: false,
      newParentalCode: false,
      confirmNewParentalCode: false,
    },
    digitNumberLength: 4,
  };

  constructor(props) {
    super(props);
    this.handleKeyPressed = this.handleKeyPressed.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(TucanoActions.getParentalCode());
    document.addEventListener("keydown", this.handleKeyPressed, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPressed, false);
  }

  handleSubmit() {
    const { t } = this.props;
    this.props
      .dispatch(TucanoActions.setParentalCode(this.state.data.newParentalCode))
      .then(() => {
        if (this.props.closeModal) {
          this.props.closeModal();
        }
        this.props.dispatch(
          addToast({
            text: t("Your parental code has been successfully updated"),
            className: "primary",
            duration: 6000,
          })
        );
      });
  }

  handleKeyPressed(event) {
    if (event.key === "Enter") {
      if (
        this.state.focus.currentParentalCode &&
        this.state.focus.newParentalCode &&
        this.state.focus.confirmNewParentalCode &&
        this.state.error.currentParentalCode === "" &&
        this.state.error.newParentalCode === "" &&
        this.state.error.confirmNewParentalCode === "" &&
        this.state.data.newParentalCode ===
          this.state.data.confirmNewParentalCode &&
        this.props.parentalCode === this.state.data.currentParentalCode
      ) {
        this.handleSubmit();
      }
    }
  }

  handleNewAdultCodeChange(key, value) {
    const updatedState = this.state;
    const { t } = this.props;
    updatedState["data"][key] = value;

    if (
      ADULT_CODE_REGEXP.test(value) &&
      value.length === this.state.digitNumberLength
    ) {
      updatedState["error"][key] = "";
    } else {
      updatedState["error"][key] = t("Parental code is a 4 digit number");
    }
    updatedState["focus"][key] = true;
    this.setState(updatedState);
  }

  render() {
    const { parentalCode, isLoading, isUpdating } = this.props;
    return (
      <Fragment>
        {isLoading && (
          <div className={style.loader}>
            <Loader />{" "}
          </div>
        )}
        {!isLoading && (
          <Fragment>
            <div className={style.root}>
              <div className={style.form}>
                <div className={style.container}>
                  <label className={style.title}>
                    <Trans>Enter current parental code</Trans>
                  </label>
                  <Input
                    type={InputType.PASSWORD}
                    onChange={(value) =>
                      this.handleNewAdultCodeChange(
                        "currentParentalCode",
                        value
                      )
                    }
                    value={this.state.data.currentParentalCode}
                  />
                  {this.state.error.currentParentalCode && (
                    <p className={style.error}>
                      <Trans>{this.state.error.currentParentalCode}</Trans>
                    </p>
                  )}
                  {this.state.focus.currentParentalCode &&
                    this.state.data.currentParentalCode !== parentalCode && (
                      <p className={style.error}>
                        <Trans>You have entered the wrong parental code</Trans>
                      </p>
                    )}
                </div>
                <div className={style.container}>
                  <label className={style.title}>
                    <Trans>New parental code</Trans>
                  </label>
                  <Input
                    type={InputType.PASSWORD}
                    onChange={(value) =>
                      this.handleNewAdultCodeChange("newParentalCode", value)
                    }
                    value={this.state.data.newParentalCode}
                  />
                  {this.state.error.newParentalCode && (
                    <p className={style.error}>
                      <Trans>{this.state.error.newParentalCode}</Trans>
                    </p>
                  )}
                </div>
                <div className={style.container}>
                  <label className={style.title}>
                    <Trans>Confirm new parental code</Trans>
                  </label>
                  <Input
                    type={InputType.PASSWORD}
                    onChange={(value) =>
                      this.handleNewAdultCodeChange(
                        "confirmNewParentalCode",
                        value
                      )
                    }
                    value={this.state.data.confirmNewParentalCode}
                  />
                  {this.state.error.confirmNewParentalCode && (
                    <p className={style.error}>
                      <Trans>{this.state.error.confirmNewParentalCode}</Trans>
                    </p>
                  )}
                  {this.state.data.confirmNewParentalCode &&
                    this.state.data.newParentalCode !==
                      this.state.data.confirmNewParentalCode && (
                      <p className={style.error}>
                        <Trans>The parental codes are different</Trans>
                      </p>
                    )}
                </div>
              </div>
              <div className={style.buttonContainer}>
                {isUpdating && (
                  <Button
                    rootClassName={style.submitButton}
                    type={ButtonType.LOADING}
                  >
                    <Trans>Change parental code</Trans>
                  </Button>
                )}

                {!isUpdating && (
                  <Button
                    rootClassName={style.submitButton}
                    type={
                      !this.state.focus.currentParentalCode ||
                      !this.state.focus.newParentalCode ||
                      !this.state.focus.confirmNewParentalCode ||
                      this.state.error.currentParentalCode !== "" ||
                      this.state.error.newParentalCode !== "" ||
                      this.state.error.confirmNewParentalCode !== "" ||
                      this.state.data.newParentalCode !==
                        this.state.data.confirmNewParentalCode ||
                      this.props.parentalCode !==
                        this.state.data.currentParentalCode
                        ? ButtonType.DISABLED
                        : ButtonType.NORMAL
                    }
                    onClick={this.handleSubmit.bind(this)}
                  >
                    <Trans>Change parental code</Trans>
                  </Button>
                )}
              </div>
              <div className={style.infoContainer}>
                {/* <p className={style.text}>
                  <Trans>Forgotten parental code</Trans> ?{" "}
                  <span className={style.highlightedText}>
                    <Trans>Reset it</Trans>
                  </span>
                </p> */}
                <p className={style.text}>
                  <Trans>Note:Your default parental code is 1234</Trans>
                </p>
              </div>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default compose(
  connect((state) => {
    return {
      isLoading: state.account.parentalCode.loading,
      isUpdating: state.account.parentalCode.updating,
      parentalCode: TucanoSelectors.getParentalCode(state),
    };
  }),
  withTranslation()
)(FormChangeParentalCode);
